import React from "react";

interface SuccessIconProps {
  size?: number | string;
  className?: string;
}

const SuccessIcon: React.FC<SuccessIconProps> = ({
  size = 50,
  className = "",
}) => (
  <div className={`flex justify-center ${className}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50" cy="50" r="50" fill="#23A26D" fillOpacity="0.12" />
      <path
        d="M49.9995 25C36.2245 25 24.9995 36.225 24.9995 50C24.9995 63.775 36.2245 75 49.9995 75C63.7745 75 74.9995 63.775 74.9995 50C74.9995 36.225 63.7745 25 49.9995 25ZM61.9495 44.25L47.7745 58.425C47.4245 58.775 46.9495 58.975 46.4495 58.975C45.9495 58.975 45.4745 58.775 45.1245 58.425L38.0495 51.35C37.3245 50.625 37.3245 49.425 38.0495 48.7C38.7745 47.975 39.9745 47.975 40.6995 48.7L46.4495 54.45L59.2995 41.6C60.0245 40.875 61.2245 40.875 61.9495 41.6C62.6745 42.325 62.6745 43.5 61.9495 44.25Z"
        fill="#23A26D"
      />
    </svg>
  </div>
);

export default SuccessIcon;
